import * as React from "react";
import { FilterMetadata } from "../../types";
import { useDebouncedState } from "~/utils/useDebouncedInput";
import { Input } from "~/components/ui/input";

// // // //

export function FloatValueInput(props: {
    value: number | null;
    filterMeta: FilterMetadata;
    onChange: (updatedValue: number | null) => void;
}) {
    const { filterMeta } = props;
    const { content } = filterMeta;

    const [value, onChange] = useDebouncedState<number | null>({
        debounceTimeout: 800,
        value: props.value,
        onChange: props.onChange,
    });

    return (
        <Input
            type="number"
            value={value as number}
            placeholder={content.label}
            onChange={(e) => {
                // Invoke props.onChange with null if the value has been cleared
                if (e.currentTarget.value === "") {
                    onChange(null);
                    return;
                }

                const updatedValue = Number(e.currentTarget.value);
                onChange(updatedValue);
            }}
        />
    );
}

export function PositiveFloatValueInput(props: {
    value: number | null;
    filterMeta: FilterMetadata;
    onChange: (updatedValue: number | null) => void;
}) {
    const { filterMeta } = props;
    const { content } = filterMeta;

    const [value, onChange] = useDebouncedState<number | null>({
        debounceTimeout: 800,
        value: props.value,
        onChange: props.onChange,
    });

    return (
        <Input
            min={0}
            type="number"
            value={value as number}
            placeholder={content.label}
            onChange={(e) => {
                // Invoke props.onChange with null if the value has been cleared
                if (e.currentTarget.value === "") {
                    onChange(null);
                    return;
                }

                const updatedValue = Number(e.currentTarget.value);
                onChange(updatedValue);
            }}
        />
    );
}
